import React from "react";
import { styled } from "@mui/material/styles";
import usePageview from "core/hooks/usePageview";
import useScrollToTop from "core/hooks/useScrollToTop";
import FavoriteContents from "arena/components/FavoriteContents";
import ArenaHelmet from "arena/components/ArenaHelmet";
import { useTranslation } from "react-i18next";
import { useArena } from "core/components/ArenaProvider";
import { useLocation } from "react-router-dom";

const Root = styled("div")(({ theme }) => ({
  overflow: "hidden",
  padding: theme.spacing(0),
  [theme.breakpoints.up("sm")]: {
    padding: theme.spacing(0, 3),
  },
}));

const LIMIT = 12;

export default function Favorites() {
  const { t } = useTranslation("arena");

  const arena = useArena();
  const location = useLocation();

  usePageview(location.pathname, "Favorites");
  useScrollToTop();

  const title =
    new URLSearchParams(location.search).get("title") || t("favorites.title");

  return (
    <Root>
      <ArenaHelmet title={title} />
      <FavoriteContents
        arena={arena}
        view="GRID"
        limit={LIMIT}
        title={title}
        loadMore
      />
    </Root>
  );
}
